import React, { useState } from "react";

// var pageName = 'Profile'; // Default page name
// var selectedCategory = 'null'; // Default category
var currentuserid = '';

// Check if the URL has a query string and extract the CategoryName if it exists
let paramString = window.location.href.split('?')[1];
if (paramString) {
  let queryString = new URLSearchParams(paramString);
  for (let pair of queryString.entries()) {
    if (pair[0] === 'CategoryName') {
      // selectedCategory = pair[1];
    }
    if (pair[0] === 'pageName') {
      // pageName = pair[1];
    }
    if (pair[0] === 'userid') {
      currentuserid = pair[1];
      document.getElementById('userid-label').innerText = currentuserid;
    }
  }
}


function Dashboard() { 

  const [users, setUsers] = useState([]);
  const [attempts, setAttempts] = useState([]);
  const [maq, setMAQ] = useState([]);
  const [mcaq, setMCAQ] = useState([]);
  const [miaq, setMIAQ] = useState([]);
  const [loading, setLoading] = useState({
    users: false,
    attempts: false,
  });

  const [selectedDate, setSelectedDate] = useState('');

  return (
    <div style={{ padding: '10px', fontFamily: 'Arial, sans-serif', fontSize: '1.1em' }}>
      <h3 style={{ color: 'blue', textAlign: 'center' }}>Dashboard</h3>
      
      {/* Dashboard Filter - moved above both sections */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '20px' }}>
        Dashboard Filter
        <input
          type="date"
          value={selectedDate}
          onChange={e => setSelectedDate(e.target.value)}
          style={{ padding: '6px', fontSize: '1em' }}
        />
      </div>

      {/* Score Based Leaderboard */}
      <h4 style={{ color: 'blue', marginTop: '40px', textAlign: 'center' }}>Score Based Leaderboard</h4>
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <button
          onClick={async () => {
            setLoading(prev => ({ ...prev, leaderboard: true }));
            try {
              const url = 'https://kc-service-eight.vercel.app/dashboard_scoreleaders';
              const response = await fetch(url, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'Accept': 'application/json'
                },
                body: JSON.stringify({
                  filterafterdate: selectedDate
                })
              });
              const data = await response.json();
              setUsers(data.dashboard || []);
              console.log('Leaderboard data:', data);
            } catch (error) {
              console.error('Error fetching leaderboard:', error);
              setUsers([]);
            }
            setLoading(prev => ({ ...prev, leaderboard: false }));
          }}
          disabled={loading.leaderboard}
        >
          {loading.leaderboard ? 'Loading...' : 'Show Score Leaders'}
        </button>
      </div>

      {users.length > 0 && (
        <table style={{ marginTop: '20px', width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              <th style={{ border: '1px solid #ccc', padding: '8px' }}>UserId</th>
              <th style={{ border: '1px solid #ccc', padding: '8px' }}>Name</th>
              <th style={{ border: '1px solid #ccc', padding: '8px' }}>Score</th>
              <th style={{ border: '1px solid #ccc', padding: '8px' }}>Avg score</th>
              <th style={{ border: '1px solid #ccc', padding: '8px' }}>Total Responses</th>
            </tr>
          </thead>
          <tbody>
            {users.map((user, idx) => (
              <tr key={user.id || idx}>
                <td style={{ border: '1px solid #ccc', padding: '8px' }}>{user.userid}</td>
                <td style={{ border: '1px solid #ccc', padding: '8px' }}>{user.username}</td>
                <td style={{ border: '1px solid #ccc', padding: '8px' }}>{user.total_score}</td>
                <td style={{ border: '1px solid #ccc', padding: '8px' }}>{user.avg_score}</td>
                <td style={{ border: '1px solid #ccc', padding: '8px' }}>{user.responses_count}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {/* Attempt Based Leaderboard */}
      <h4 style={{ color: 'blue', marginTop: '40px', textAlign: 'center' }}>Attempt Based Leaderboard</h4>
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <button
          onClick={async () => {
            setLoading(prev => ({ ...prev, attemptLeaderboard: true }));
            try {
              const url = 'https://kc-service-eight.vercel.app/dashboard_attemptleaders';
              const response = await fetch(url, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'Accept': 'application/json'
                },
                body: JSON.stringify({
                  filterafterdate: selectedDate
                })
              });
              const data = await response.json();
              setAttempts(data.dashboard || []);
              console.log('Attempt leaderboard data:', data.dashboard);
            } catch (error) {
              console.error('Error fetching attempt leaderboard:', error);
              setAttempts([]);
            }
            setLoading(prev => ({ ...prev, attemptLeaderboard: false }));
          }}
          disabled={loading.attemptLeaderboard}
        >
          {loading.attemptLeaderboard ? 'Loading...' : 'Show Attempt Leaderboard'}
        </button>
      </div>

      {attempts.length > 0 && (
        <table style={{ marginTop: '20px', width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              <th style={{ border: '1px solid #ccc', padding: '8px' }}>UserId</th>
              <th style={{ border: '1px solid #ccc', padding: '8px' }}>Name</th>
              <th style={{ border: '1px solid #ccc', padding: '8px' }}>Attempts</th>
            </tr>
          </thead>
          <tbody>
            {attempts.map((user, idx) => (
              <tr key={user.id || idx}>
                <td style={{ border: '1px solid #ccc', padding: '8px' }}>{user.userid}</td>
                <td style={{ border: '1px solid #ccc', padding: '8px' }}>{user.username}</td>
                <td style={{ border: '1px solid #ccc', padding: '8px' }}>{user.responses_count}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {/* Most Answered Questions Section */}
      <h4 style={{ color: 'blue', marginTop: '40px', textAlign: 'center' }}>Most Answered Questions</h4>
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <button
          onClick={async () => {
            setLoading(prev => ({ ...prev, attemptmaq: true }));
            try {
              const url = 'https://kc-service-eight.vercel.app/questions_mostanswered';
              const response = await fetch(url, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'Accept': 'application/json'
                },
                body: JSON.stringify({
                  filterafterdate: selectedDate
                })
              });
              const data = await response.json();
              setMAQ(data.dashboard || []);
              console.log('Attempt questions data:', data);
            } catch (error) {
              console.error('Error fetching attempt leaderboard:', error);
              setMAQ([]);
            }
            setLoading(prev => ({ ...prev, attemptmaq: false }));
          }}
          disabled={loading.attemptmaq}
        >
          {loading.attemptmaq ? 'Loading...' : 'Show Most Answered Questions'}
        </button>
      </div>

      {maq.length > 0 && (
        <table style={{ marginTop: '20px', width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              <th style={{ border: '1px solid #ccc', padding: '8px' }}>QuestionID</th>
              <th style={{ border: '1px solid #ccc', padding: '8px' }}>QuestionText</th>
              <th style={{ border: '1px solid #ccc', padding: '8px' }}>Responses</th>
            </tr>
          </thead>
          <tbody>
            {maq.map((question, idx) => (
              <tr key={question.id || idx}>
                <td style={{ border: '1px solid #ccc', padding: '8px' }}>{question.QuestionID}</td>
                <td style={{ border: '1px solid #ccc', padding: '8px' }}>{question.QuestionText}</td>
                <td style={{ border: '1px solid #ccc', padding: '8px' }}>{question.responses_count}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      
      {/* Most Correclty Answered Questions Section */}
      <h4 style={{ color: 'blue', marginTop: '40px', textAlign: 'center' }}>Most Correctly Answered Questions</h4>
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <button
          onClick={async () => {
            setLoading(prev => ({ ...prev, attemptmcaq: true }));
            try {
              const url = 'https://kc-service-eight.vercel.app/questions_mostcorrectlyanswered';
              const response = await fetch(url, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'Accept': 'application/json'
                },
                body: JSON.stringify({
                  filterafterdate: selectedDate
                })
              });
              const data = await response.json();
              setMCAQ(data.dashboard || []);
              console.log('correctly answered questions data:', data);
            } catch (error) {
              console.error('Error fetching correctly answered questions leaderboard:', error);
              setMCAQ([]);
            }
            setLoading(prev => ({ ...prev, attemptmcaq: false }));
          }}
          disabled={loading.attemptmcaq}
        >
          {loading.attemptmcaq ? 'Loading...' : 'Show Most correctly Answered Questions'}
        </button>
      </div>

      {mcaq.length > 0 && (
        <table style={{ marginTop: '20px', width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              <th style={{ border: '1px solid #ccc', padding: '8px' }}>QuestionID</th>
              <th style={{ border: '1px solid #ccc', padding: '8px' }}>QuestionText</th>
              <th style={{ border: '1px solid #ccc', padding: '8px' }}>Responses</th>
            </tr>
          </thead>
          <tbody>
            {mcaq.map((question, idx) => (
              <tr key={question.id || idx}>
                <td style={{ border: '1px solid #ccc', padding: '8px' }}>{question.QuestionID}</td>
                <td style={{ border: '1px solid #ccc', padding: '8px' }}>{question.QuestionText}</td>
                <td style={{ border: '1px solid #ccc', padding: '8px' }}>{question.responses_count}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {/* Most Inorreclty Answered Questions Section */}
      <h4 style={{ color: 'blue', marginTop: '40px', textAlign: 'center' }}>Most Incorrectly Answered Questions</h4>
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <button
          onClick={async () => {
            setLoading(prev => ({ ...prev, attemptmiaq: true }));
            try {
              const url = 'https://kc-service-eight.vercel.app/questions_mostincorrectlyanswered';
              const response = await fetch(url, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'Accept': 'application/json'
                },
                body: JSON.stringify({
                  filterafterdate: selectedDate
                })
              });
              const data = await response.json();
              setMIAQ(data.dashboard || []);
              console.log('incorrectly answered questions data:', data);
            } catch (error) {
              console.error('Error fetching incorrectly answered questions leaderboard:', error);
              setMIAQ([]);
            }
            setLoading(prev => ({ ...prev, attemptmiaq: false }));
          }}
          disabled={loading.attemptmcaq}
        >
          {loading.attemptmcaq ? 'Loading...' : 'Show Most incorrectly Answered Questions'}
        </button>
      </div>

      {miaq.length > 0 && (
        <table style={{ marginTop: '20px', width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              <th style={{ border: '1px solid #ccc', padding: '8px' }}>QuestionID</th>
              <th style={{ border: '1px solid #ccc', padding: '8px' }}>QuestionText</th>
              <th style={{ border: '1px solid #ccc', padding: '8px' }}>Responses</th>
            </tr>
          </thead>
          <tbody>
            {miaq.map((question, idx) => (
              <tr key={question.id || idx}>
                <td style={{ border: '1px solid #ccc', padding: '8px' }}>{question.QuestionID}</td>
                <td style={{ border: '1px solid #ccc', padding: '8px' }}>{question.QuestionText}</td>
                <td style={{ border: '1px solid #ccc', padding: '8px' }}>{question.responses_count}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

    </div>
  );
}

export default Dashboard;